export function formatParams(params = {}) {
  return Reflect.ownKeys(params).sort().reduce((Accumulator, Current) => ({ ...Accumulator, [Current]: params[Current] }), {});
}

export function queryString(params = {}) {
  return Reflect.ownKeys(params).filter(item => params[item] !== undefined && params[item] !== '').map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
}